<template>
  <h1>Logout</h1>
</template>

<script>
export default {};
</script>

<style>
</style>